import { useState } from "react"
import { useLocation } from "react-router-dom"
import Darkmode from '../../Dark mode/Darkmode'
import "../../../App.css"

export default function Navbar() {
    const [Layout, setLayout] = useState("grid")
    const location = useLocation();



    const LayoutHandler = () => {
        if (Layout === "grid") {
            setLayout("list")
            document.getElementById("NotesContainer").classList.remove("grid")
            document.getElementById("NotesContainer").classList.add("list")
        } else if (Layout === "list") {
            setLayout("grid")
            document.getElementById("NotesContainer").classList.remove("list")
            document.getElementById("NotesContainer").classList.add("grid")
        }
    }

    return (
        <nav
            id="Navbar"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                position: "fixed",
                bottom: "15px",
                left: "50%",
                transform: "translate(-50%, 0)",

                margin: "auto",
                width: "230px",
                fontSize: "35px",
                zIndex: "999",
            }}>
            {
                (location.pathname === "/Home/allNotes") === true ?
                    <span className='mx-3' onClick={LayoutHandler}>
                        {Layout === "grid" ? (
                            <i className="bi bi-list text"></i>
                        ) : (
                            <i className="bi bi-grid text"></i>
                        )}
                    </span>
                    :
                    <span className='mx-3' style={{ opacity: "0.5" }}>
                        {Layout === "grid" ? (
                            <i className="bi bi-list text"></i>
                        ) : (
                            <i className="bi bi-grid text"></i>
                        )}
                    </span>
            }


            <span className='mx-3' data-bs-toggle="modal" data-bs-target="#addnewNotes">
                <i className="bi bi-plus-square-dotted text"></i>
            </span>


            <span className='mx-3'>
                <Darkmode />
            </span>

        </nav>
    )
}
